import { configureStore } from "@reduxjs/toolkit"
import { setupListeners } from "@reduxjs/toolkit/query"
import { useDispatch, useSelector } from "react-redux"
import { injectStore } from "@/api/service"
import { api } from "./api"
import { AppSlice } from "./slices/app/slice.ts"
import { DevToolsSlice } from "./slices/devTools/slice.ts"
import { FindMatchSlice } from "./slices/findMatch/slice.ts"
import { GameplaySlice } from "./slices/gameplay/slice.ts"
import { MatchSlice } from "./slices/match/slice.ts"
import { PlayerSlice, setIsAuthorized } from "./slices/player/slice.ts"

export const store = configureStore({
  devTools: import.meta.env.VITE_NODE_ENV !== "production",
  reducer: {
    [api.reducerPath]: api.reducer,
    [AppSlice.name]: AppSlice.reducer,
    [GameplaySlice.name]: GameplaySlice.reducer,
    [MatchSlice.name]: MatchSlice.reducer,
    [PlayerSlice.name]: PlayerSlice.reducer,
    [FindMatchSlice.name]: FindMatchSlice.reducer,
    [DevToolsSlice.name]: DevToolsSlice.reducer
  },
  middleware: (getDefaultMiddleware) => {
    const middleware = getDefaultMiddleware({
      serializableCheck: false
    })

    return middleware.concat(api.middleware)
  }
})

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch
export const useAppDispatch: () => AppDispatch = useDispatch
export const useAppSelector = <T,>(cb: (state: RootState) => T) =>
  useSelector(cb)

setupListeners(store.dispatch)
injectStore(store, setIsAuthorized)
